"use client";

import classNames from "classnames";

/**
 * variant: "white" | "lighter-gray"
 * size: "sm" (or nothing for default md size)
 * options: [{ value: string, label: string }]
 * selectedValue: string
 * onChange: (value: string) => void
 * disabled: boolean
 * name: string — used for the radio input group
 */

function SegmentedControl({
  options,
  selectedValue,
  onChange,
  name,
  disabled = false,
  variant = "white",
  size,
  className,
}) {
  return (
    <div
      className={classNames(
        "segmented-control",
        `segmented-control-${variant}`,
        disabled && "disabled",
        className,
      )}
    >
      {options.map((option) => (
        <label
          key={option.value}
          className={classNames(
            "segmented-control-option",
            selectedValue === option.value && "active",
            size,
          )}
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={() => onChange(option.value)}
            disabled={disabled}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
}

export default SegmentedControl;
